import React, { useMemo } from 'react';
import {
  getCollectionById,
  listDocuments,
  type Document,
  type Widget,
} from '@airhead-games/shared/content';
import DocumentListingGrid from '@/content/rendering/documentListings/DocumentListingGrid';

interface WidgetDocumentListProps {
  widget: Extract<Widget, { type: 'documentList' }>;
}

const WidgetDocumentList: React.FC<WidgetDocumentListProps> = ({ widget }) => {
  const documents = useMemo(() => {
    if (widget.source.type === 'collection') {
      const collection = getCollectionById(widget.source.collectionId);
      if (!collection) {
        return [];
      }

      const kindByCollectionId: Record<string, Document['kind']> = {
        'collection:games': 'game',
        'collection:features': 'feature',
        'collection:blog': 'blog',
        'collection:reports': 'report',
      };

      return listDocuments({
        kind: kindByCollectionId[collection.id],
        sortBy:
          collection.id === 'collection:blog'
            ? 'publishedAt-desc'
            : 'title-asc',
      });
    }

    return listDocuments({
      kind: widget.source.kind,
      tags: widget.source.tags,
      relatedTo: widget.source.relatedToDocumentId,
      sortBy: widget.source.sortBy,
    });
  }, [widget]);

  const limitedDocuments = widget.limit
    ? documents.slice(0, widget.limit)
    : documents;
  const isReportList =
    (widget.source.type === 'query' && widget.source.kind === 'report') ||
    (widget.source.type === 'collection' &&
      widget.source.collectionId === 'collection:reports');

  return (
    <DocumentListingGrid
      documents={limitedDocuments}
      featuredFirst={widget.layout === 'featured-grid'}
      variant={isReportList ? 'report-month' : 'default'}
    />
  );
};

export default WidgetDocumentList;
